// import { useRef, useState, useCallback, useEffect } from "react";
// import { Camera, RotateCcw, Check, X, LogIn, LogOut } from "lucide-react";

// export default function AttendanceCamera() {
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const streamRef = useRef(null);

//   const [isCameraOn, setIsCameraOn] = useState(false);
//   const [capturedImage, setCapturedImage] = useState(null);
//   const [error, setError] = useState("");
//   const [records, setRecords] = useState([]);
//   const [employeeName, setEmployeeName] = useState("");

//   // Start the webcam
//   const startCamera = useCallback(async () => {
//     setError("");
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: { facingMode: "user", width: 640, height: 480 },
//         audio: false,
//       });
//       streamRef.current = stream;
//       if (videoRef.current) {
//         videoRef.current.srcObject = stream;
//       }
//       setIsCameraOn(true);
//       setCapturedImage(null);
//     } catch (err) {
//       setError(
//         err.name === "NotAllowedError"
//           ? "Camera permission denied. Please allow camera access."
//           : "Could not access camera: " + err.message
//       );
//     }
//   }, []);

//   // Stop the webcam (always do this when done, to free the device)
//   const stopCamera = useCallback(() => {
//     if (streamRef.current) {
//       streamRef.current.getTracks().forEach((track) => track.stop());
//       streamRef.current = null;
//     }
//     setIsCameraOn(false);
//   }, []);

//   // Clean up camera on unmount
//   useEffect(() => {
//     return () => stopCamera();
//   }, [stopCamera]);

//   // Capture a still frame from the video onto a canvas
//   const capturePhoto = () => {
//     const video = videoRef.current;
//     const canvas = canvasRef.current;
//     if (!video || !canvas) return;

//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;
//     const ctx = canvas.getContext("2d");
//     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

//     const dataUrl = canvas.toDataURL("image/jpeg", 0.9);
//     setCapturedImage(dataUrl);
//   };

//   const retake = () => setCapturedImage(null);

//   // Mark attendance (check-in or check-out) with the captured photo
//   const markAttendance = async (type) => {
//     if (!capturedImage) return;

//     const record = {
//       id: Date.now(),
//       name: employeeName || "Unknown",
//       type, // "in" or "out"
//       timestamp: new Date().toLocaleString(),
//       photo: capturedImage,
//     };

//     // TODO: replace with your real API call, e.g.:
//     // await fetch("/api/attendance", {
//     //   method: "POST",
//     //   headers: { "Content-Type": "application/json" },
//     //   body: JSON.stringify(record),
//     // });

//     setRecords((prev) => [record, ...prev]);
//     setCapturedImage(null);
//     stopCamera();
//   };

//   return (
//     <div className="max-w-md mx-auto p-6 bg-white rounded-xl shadow-md space-y-4">
//       <h2 className="text-lg font-semibold text-gray-800">Mark Attendance</h2>

//       <input
//         type="text"
//         placeholder="Employee name"
//         value={employeeName}
//         onChange={(e) => setEmployeeName(e.target.value)}
//         className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//       />

//       {error && (
//         <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-2">
//           {error}
//         </p>
//       )}

//       <div className="relative bg-gray-900 rounded-lg overflow-hidden aspect-video flex items-center justify-center">
//         {!isCameraOn && !capturedImage && (
//           <button
//             onClick={startCamera}
//             className="flex flex-col items-center gap-2 text-gray-300 hover:text-white"
//           >
//             <Camera size={36} />
//             <span className="text-sm">Start Camera</span>
//           </button>
//         )}

//         {isCameraOn && !capturedImage && (
//           <video
//             ref={videoRef}
//             autoPlay
//             playsInline
//             muted
//             className="w-full h-full object-cover"
//           />
//         )}

//         {capturedImage && (
//           <img
//             src={capturedImage}
//             alt="Captured"
//             className="w-full h-full object-cover"
//           />
//         )}
//       </div>

//       {/* Hidden canvas used only for grabbing a frame from the video */}
//       <canvas ref={canvasRef} className="hidden" />

//       <div className="flex gap-2">
//         {isCameraOn && !capturedImage && (
//           <>
//             <button
//               onClick={capturePhoto}
//               className="flex-1 bg-blue-600 text-white rounded-md py-2 text-sm font-medium hover:bg-blue-700 flex items-center justify-center gap-2"
//             >
//               <Camera size={16} /> Capture
//             </button>
//             <button
//               onClick={stopCamera}
//               className="px-4 bg-gray-100 text-gray-700 rounded-md py-2 text-sm hover:bg-gray-200 flex items-center justify-center gap-1"
//             >
//               <X size={16} /> Cancel
//             </button>
//           </>
//         )}

//         {capturedImage && (
//           <>
//             <button
//               onClick={() => markAttendance("in")}
//               className="flex-1 bg-green-600 text-white rounded-md py-2 text-sm font-medium hover:bg-green-700 flex items-center justify-center gap-2"
//             >
//               <LogIn size={16} /> Check In
//             </button>
//             <button
//               onClick={() => markAttendance("out")}
//               className="flex-1 bg-orange-600 text-white rounded-md py-2 text-sm font-medium hover:bg-orange-700 flex items-center justify-center gap-2"
//             >
//               <LogOut size={16} /> Check Out
//             </button>
//             <button
//               onClick={retake}
//               className="px-3 bg-gray-100 text-gray-700 rounded-md py-2 text-sm hover:bg-gray-200 flex items-center justify-center"
//             >
//               <RotateCcw size={16} />
//             </button>
//           </>
//         )}
//       </div>

//       {records.length > 0 && (
//         <div className="pt-3 border-t border-gray-100 space-y-2">
//           <h3 className="text-sm font-medium text-gray-700">
//             Recent records
//           </h3>
//           <ul className="space-y-2 max-h-48 overflow-y-auto">
//             {records.map((r) => (
//               <li
//                 key={r.id}
//                 className="flex items-center gap-3 text-sm bg-gray-50 rounded-md p-2"
//               >
//                 <img
//                   src={r.photo}
//                   alt={r.name}
//                   className="w-10 h-10 rounded-full object-cover"
//                 />
//                 <div className="flex-1">
//                   <p className="font-medium text-gray-800">{r.name}</p>
//                   <p className="text-xs text-gray-500">{r.timestamp}</p>
//                 </div>
//                 <span
//                   className={`text-xs px-2 py-1 rounded-full font-medium ${
//                     r.type === "in"
//                       ? "bg-green-100 text-green-700"
//                       : "bg-orange-100 text-orange-700"
//                   }`}
//                 >
//                   <Check size={12} className="inline mr-1" />
//                   {r.type === "in" ? "IN" : "OUT"}
//                 </span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// }

// import { useRef } from "react";

// function AttendanceCamera() {
//   const videoRef = useRef(null);
//   const streamRef = useRef(null);

//   const openCamera = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: true,
//       });

//       streamRef.current = stream;
//       videoRef.current.srcObject = stream;
//     } catch (error) {
//       console.error(error);
//       alert("Unable to access camera");
//     }
//   };

//   const closeCamera = () => {
//     streamRef.current?.getTracks().forEach((track) => track.stop());
//     videoRef.current.srcObject = null;
//   };

//   return (
//     <div>
//       <button onClick={openCamera}>Open Camera</button>
//       <button onClick={closeCamera}>Close Camera</button>

//       <br />

//       <video
//         ref={videoRef}
//         autoPlay
//         playsInline
//         style={{ width: "400px" }}
//       />
//     </div>
//   );
// }

// export default AttendanceCamera;

import React, { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

const AttendanceCamera = () => {
  const webcamRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(null);
  const [error, setError] = useState("");

  const capture = useCallback(() => {
    if (!webcamRef.current) return;

    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
  }, []);

  const handleUserMediaError = useCallback((error) => {
    console.error("Camera error:", error);
    setError("Unable to access camera. Please allow camera permission.");
  }, []);

  console.log("mediaDevices:", navigator.mediaDevices);
console.log("getUserMedia:", navigator.mediaDevices?.getUserMedia);


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2>Camera Stream</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        width={480}
        height={360}
        onUserMediaError={handleUserMediaError}
      />

      <button
        onClick={capture}
        style={{
          margin: "20px",
          padding: "10px 20px",
          cursor: "pointer",
        }}
      >
        Capture Photo
      </button>

      {imgSrc && (
        <div>
          <h3>Preview:</h3>
          <img
            src={imgSrc}
            alt="Captured"
            style={{ width: "480px" }}
          />
        </div>
      )}
    </div>
  );
};

export default AttendanceCamera;
